import type { EVMAddress } from "@opensea/utils"
import { useEffect, useState } from "react"
import { usePublicClient } from "wagmi"
import { isEvmAddress } from "../../lib/address"
import { useAddress } from "../../polychain/hooks"
import { useChainArch } from "../../polychain/hooks/useChainArch"

export function useIsSmartContractWallet() {
  const [isSmartContractWallet, setIsSmartContractWallet] = useState(false)

  const address = useAddress()
  const chainArch = useChainArch()
  const client = usePublicClient()

  useEffect(() => {
    let cancelled = false
    if (address && isEvmAddress(address) && chainArch === "EVM") {
      client
        ?.getCode({
          address: address as EVMAddress,
        })
        .then(code => {
          if (!cancelled) {
            setIsSmartContractWallet(code !== undefined)
          }
        })
    }
    return () => {
      cancelled = true
    }
  }, [address, chainArch, client])

  return isSmartContractWallet
}
